import { inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, of, Subscription } from 'rxjs';
import { HttpService } from './http.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { Product } from '@shared/models';
export interface Totals {
    start?: number;
    end?: number;
    total: number | null;
}
@Injectable()
export class ProductsService implements OnDestroy {
    private httpService = inject(HttpService);

    products$ = new BehaviorSubject<Product[]>([]);
    totals$ = new BehaviorSubject<Totals>({ start: 0, end: 0, total: null });
    searching$ = new BehaviorSubject<boolean>(false);
    error$ = new BehaviorSubject<boolean>(false);

    limit = 28;

    private subscriptions = new Subscription();

    dispatch(page: number, categoryId: string | null, search: string): void {
        this.searching$.next(true);
        this.error$.next(false);
        this.httpService
            .getProducts(this.limit, page, categoryId ? [categoryId] : null, search)
            .pipe(
                tap((data) => {
                    this.products$.next(data.products);
                    this.totals$.next({
                        start: (page - 1) * this.limit + 1,
                        end: (page - 1) * this.limit + this.limit > data.total ? data.total : (page - 1) * this.limit + this.limit,
                        total: data.total,
                    });
                }),
                finalize(() => {
                    this.searching$.next(false);
                }),
                catchError((error) => {
                    this.error$.next(true);
                    return of(error);
                }),
            )
            .subscribe();
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
